import React from "react";
import { Link } from "react-scroll";
import portrait from "../resources/images/me.jpeg";

const ACCENT = "text-[#491704]";

export const Welcome = () => {
  return (
    <section
      id="welcome"
      className="relative min-h-screen flex items-center justify-center px-6 lg:px-12"
    >
      <div className="mx-auto w-full max-w-6xl">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          {/* Text */}
          <div className="order-2 lg:order-1 text-center lg:text-left">
            <p className="text-lg font-medium text-stone-500">
              Software Engineer
            </p>

            <h1
              className={`mt-2 text-5xl font-semibold tracking-tight sm:text-6xl lg:text-7xl ${ACCENT}`}
            >
              Elia Ritzmann
            </h1>

            <p className="mt-6 mx-auto max-w-prose text-lg leading-relaxed text-center text-stone-600
                          sm:text-xl lg:mx-0 lg:text-left lg:text-2xl">

              End-to-End-Entwicklung produktiver Web-Applikationen mit Fokus auf
              Cyber Security und nachhaltige Architektur
            </p>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
            <img
              src={portrait}
              alt="Portrait of Elia Ritzmann standing on a bridge in Zurich"
              className="w-72 sm:w-80 lg:w-[26rem] rounded-3xl object-cover shadow-lg ring-1 ring-black/5"
              loading="eager"
              decoding="async"
            />
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <Link
        to="aboutMe"
        spy
        smooth
        duration={1250}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 cursor-pointer rounded-full p-2 text-stone-700 transition hover:text-stone-900 focus:outline-none focus:ring-2 focus:ring-black/20"
        aria-label="Scroll to About Me"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-12 w-12 animate-bounce"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </Link>
    </section>
  );
};
